/**
 * SettingsFormFooter: the bar under a Settings form. It says when there
 * are unsaved changes, shows the last failed save, and holds the form's
 * buttons with Save last. Every form on Settings ends this way, so the
 * eye knows where to look.
 */

import { EYEBROW } from '@/components/ui/eyebrow'

interface SettingsFormFooterProps {
  dirty: boolean
  /** A validation or save error, shown above the buttons. */
  error?: string | null
  children: React.ReactNode
}

export function SettingsFormFooter({
  dirty,
  error = null,
  children,
}: SettingsFormFooterProps): React.JSX.Element {
  return (
    <div className="space-y-3 border-t border-border pt-6">
      {error !== null && (
        <p className="text-sm text-destructive" role="alert">
          {error}
        </p>
      )}
      <div className="flex flex-wrap items-center justify-end gap-3">
        {dirty && <p className={`mr-auto ${EYEBROW}`}>Unsaved changes</p>}
        {children}
      </div>
    </div>
  )
}
